/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AvgMeasurement } from '../models/AvgMeasurement';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AvgProxyControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns string OK
     * @throws ApiError
     */
    public getPrefixes1(): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/proxy/avg/prefixes',
        });
    }
    /**
     * @param measurementId
     * @param measurementStartDate
     * @returns AvgMeasurement OK
     * @throws ApiError
     */
    public getMeasurementHistory1(
        measurementId: string,
        measurementStartDate: string,
    ): CancelablePromise<Record<string, Record<string, Record<string, AvgMeasurement>>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/proxy/avg/measurements/{measurementId}/history',
            path: {
                'measurementId': measurementId,
            },
            query: {
                'measurementStartDate': measurementStartDate,
            },
        });
    }
}
